import React from 'react';
import { View } from './view';

export default function Sider({ collapsed }) {
  return <View collapsed={collapsed} />;
}
